module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/d3b3dcbdbf143c40a3c124213145ac80.png";